module.exports = __webpack_public_path__ + "az.4436e304d3c32ac80c24.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/az.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/az.svg
// module chunks = styles